export default {"src":"/_next/static/media/coins-icon.8fba456f.svg","height":37,"width":39};